import { Link } from 'react-router-dom'
import { routes } from 'core/routes/paths'

import c from './assets/sass/navigation.module.scss'

export const Navigation = () => {
    const items = [
        { name: 'Статистика', path: routes.adminStats, icon: '📊' },
        { name: 'Кейсы', path: routes.adminCases, icon: '🎁' },
        { name: 'Дейлик', path: routes.adminAdvent, icon: '📅' },
        { name: 'Пользователи', path: routes.adminUsers, icon: '👥' },
        { name: 'Задания', path: routes.adminTasks, icon: '✅' },
        { name: 'Рефералка', path: routes.adminReferrals, icon: '🔗' },
        { name: 'Маркетинг', path: routes.adminMarketing, icon: '📢' },
        { name: 'Триггеры', path: routes.adminTriggers, icon: '🔔' },
        { name: 'Мины', path: routes.adminMines, icon: '💣' },
        { name: 'Батлы', path: routes.adminBattles, icon: '⚔️' },
        { name: 'Лидерборд', path: routes.adminLeaderboard, icon: '🏆' },
    ]

    return (
        <div className={c.component}>
            <div className={c.grid}>
                {items.map((item) => (
                    <Link key={item.path} to={item.path} className={c.card}>
                        <span className={c.icon}>{item.icon}</span>
                        <span className={c.name}>{item.name}</span>
                    </Link>
                ))}
            </div>
        </div>
    )
}
